import {
  Component,
  ElementRef,
  EventEmitter,
  Input, OnChanges,
  OnInit,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';
import {CountryService} from "../../services/location/country.service";
import {AppAlertService} from "../../services/app-alert/app-alert.service";
import {TranslateService} from "@ngx-translate/core";
import {AppMessageService} from "../../services/app-message/app-message.service";
import { FormGroup } from '@angular/forms';
import { ParameterService } from '../../services/parameter/parameter.service';

@Component({
  selector: 'app-phone-list',
  templateUrl: './phone-list.component.html',
  styleUrl: './phone-list.component.scss'
})
export class PhoneListComponent implements OnInit, OnChanges {
  @ViewChild('phoneInput') phoneInput!: ElementRef;
  @Output() phoneItemsChange = new EventEmitter<any[]>();
  @Input() phones: any[] = [];
  @Input() types: any[] = [];
  @Input() prefixValue: boolean = true
  @Input() showPrefix:boolean=true;
  @Input() showDescriptionInput:boolean=false;
  @Input() showSearchIcon:boolean=false;//vaka için büyüteç butonu, bu butona tıklanırsa, kişinin kişi kartındaki telefon numaralarını listelemesini istiyoruz

  @Output() onSearchClicked=new EventEmitter<void>();
  @Input() title:string | null=null
  @Input() patientPhones?:number=0;
  @Input() form:FormGroup;
  @Input() isSubmit:boolean=false;
  @Input() isReadOnly=false


  phoneItems: Array<any> = [];
  newPhoneItem: boolean = false;
  newPhoneData: any = {
    type:null,
    name: '',
    prefixValue: '+90',
    phone: '',
    relativePhone: '',
    email: '',
    priority: false,
    description:''
  }
  countries: any[] = [];
  selectedRow: any;
  editingIndex: number | null = null;
  activeTooltipIndex: number | null = null;
  tooltipPosition = { x: 0, y: 0 };

  constructor(
    private readonly countryService: CountryService,
    private readonly  appAlertService: AppAlertService,
    private readonly translate: TranslateService,
    private readonly messageService: AppMessageService,
    private readonly parameterService: ParameterService,
  ) {}

  ngOnInit(): void {
    this.countryService.getAll().subscribe((res) => {
      if (res.length > 0) {
        this.countries = res.map((item: any) => ({
          name: item.name,
          value: item.phoneCode,
          label: item.phoneCode,
          flag: item.flag
        }));
      }
    });
     this.parameterService
      .getParameterValues('data-group', 'phone-types')
      .subscribe((res) => {
        this.types = res?.datas?.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            default: data?.valueObject?.default?.value,
          };
        });

        
      });
      
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["phones"]?.currentValue) {
      const phones = changes["phones"].currentValue?.length > 0 ? changes["phones"].currentValue : [];

      this.phoneItems = phones?.map((item: any) => {
        return {
          ...item,
          type: item?.type?.valueObject
            ? {
              label: item?.type?.valueObject?.name?.value,
              value: item?.type?.valueObject?.id?.value,
            }
            : {
              label: this.types.find((t) => t.value === item?.type)?.label || '',
              value: item?.type || null,
            }
        }

      });
    }
  }
  onClickSearchIcon(){
    this.onSearchClicked.emit();
  }
  newHeadItem() {
    this.cancel();
    const defaultType = this.types.find((t) => t.default === true);
    this.newPhoneItem = !this.newPhoneItem;
    if(this.phoneItems && this.phoneItems.length > 0) {
      this.newPhoneData = {
        type: defaultType,
        name: '',
        prefixValue: '+90',
        relativePhone: '',
        phone: '',
        email: '',
        priority: false,
        description:''
      }
    } else {
      this.newPhoneData = {
        type:defaultType,
        name: '',
        prefixValue: '+90',
        relativePhone: '',
        phone: '',
        email: '',
        priority: true,
        description:''
      }
    }
     setTimeout(() => {
    this.phoneInput?.nativeElement?.focus();
  }, 0);

  }

  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

  edit(item: any, index: number) {
    this.selectedRow = { ...item};
    this.editingIndex = index;
    this.hideTooltip();
    this.newPhoneItem=false;
  }

  cancel() {
    this.selectedRow = null;
    this.editingIndex = null;
  }

  isAddValid(): boolean {
    return (
      this.isPhoneValid(this.newPhoneData?.prefixValue,this.newPhoneData.phone) &&
      this.newPhoneData.prefixValue.trim() !== '' &&
      this.newPhoneData.type?.value
    );
  }

  isPhoneValid(prefixValue:string,phone: string): boolean {
    if(prefixValue==='+90'){
      const phonePattern = /^\d{10}$/;
      const res= phonePattern.test(phone);
      return res;
    }else{
      return true;
    }

  }

  add() {
    const newPhoneData = {...this.newPhoneData};
    if (this.phoneItems.length === 0) {
      newPhoneData.priority = true;
      this.completeAdd(newPhoneData);
      return;
    }
    if (newPhoneData.priority) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('shared-components.phone-priority'),
        message: this.translate.instant('shared-components.priority-change-confirm'),
        showCloseButton: true, 
        accept: () => {
          this.phoneItems.forEach(item => (item.priority = false));
          this.completeAdd(newPhoneData);
        },
        reject: () => {
        },
      });
    } else {
      this.completeAdd(newPhoneData);
    }
  }

  completeAdd(newPhoneData: any) {
    this.phoneItems.push({ ...newPhoneData });
    this.newPhoneData = {
      type: { label: '', value: null },
      name: '',
      prefixValue: '+90',
      relativePhone: '',
      phone: '',
      email: '',
      priority: false,
      description:''
    }
    this.newPhoneItem=false;

    const phoneDataToEmit = this.phoneItems.map((item: any) => {
      return { ...item, type: item?.type?.value };
    });

    this.phoneItemsChange.emit(phoneDataToEmit);
  }

  deleteItem(index: number): void {
    this.phoneItems.splice(index, 1);
    const newContacts = this.phoneItems?.map((c: any) => ({
      ...c,
      type: c?.type?.value,
    }));
    this.phoneItemsChange.emit(newContacts);
    this.hideTooltip()
  }

  saveItem() {

    if (this.editingIndex !== null) {
      const priorityCount = this.phoneItems.filter(item => item.priority).length;

      // ✅ Eğer priority false -> true'ya değişecekse sweetConfirm göster
      if (
        this.selectedRow.priority === true &&
        this.phoneItems[this.editingIndex].priority === false
      ) {
        this.appAlertService.sweetConfirm({
          header: this.translate.instant('shared-components.phone-priority'),
          message: this.translate.instant('shared-components.priority-change-confirm'),
          showCloseButton: true, 
          accept: () => {
            this.phoneItems.forEach((phoneItem, i) => {
              if (i !== this.editingIndex) {
                phoneItem.priority = false;
              }
            });
            this.completeSave();
          },
          reject: () => {
            this.cancel();
          }
        });
        return; // ✅ SweetConfirm sonrası devam etmesini engelle
      }

      // Eğer priority kaldırılacaksa ve listede sadece 1 tane varsa uyarı göster
      if (
        this.selectedRow.priority === false &&
        this.phoneItems[this.editingIndex].priority === true &&
        priorityCount === 1
      ) {
        this.messageService.infoToast(
          this.translate.instant('shared-components.priority-required'),
          this.translate.instant('shared-components.one-priority-phone'),
        );
        return;
      }
    }


   if(this.editingIndex!==null){
    const priorityCount = this.phoneItems.filter(item => item.priority).length;
     // Eğer seçilen satır priority ise ve birden fazla telefon varsa sweetConfirm göster
    if (this.selectedRow.priority && priorityCount ===1 && this.phoneItems[this.editingIndex].priority === false) {
      this.appAlertService.sweetConfirm({
        header: this.translate.instant('shared-components.phone-priority'),
        message: this.translate.instant('shared-components.priority-change-confirm'),
        showCloseButton: true, 
        accept: () => {
          this.phoneItems.forEach((phoneItem, i) => {
            if (i !== this.editingIndex) {
              phoneItem.priority = false;
            }
          });
          this.completeSave();
        },
        reject: () => {
          this.cancel();
        }
      });
    } else {
      this.completeSave();
    }
   }





  }


  completeSave() {
    if (this.editingIndex !== null) {
      this.phoneItems[this.editingIndex] = { ...this.selectedRow };
    }

    const phoneDataToEmit = this.phoneItems.map((item: any) => {
      return { ...item, type: item?.type?.value };
    });
    this.phoneItemsChange.emit(phoneDataToEmit);
    this.selectedRow = null;
    this.editingIndex = null;
  }

  showTooltip(index: number, event: MouseEvent) {
    this.activeTooltipIndex = index;
    this.tooltipPosition = { x: event.clientX + 10, y: event.clientY + 10 };
  }

  hideTooltip() {
    this.activeTooltipIndex = null;
  }

  handlePrefixChange(event: any) {
    if (this.editingIndex !== null) {

      const item=this.phoneItems[this.editingIndex];
      if (item?.prefixValue !== event) {
        this.selectedRow.phone = '';
      }
      if(item?.phone!==this.selectedRow?.phone){
        this.selectedRow.phone = '';
      }
    }

  }

}
